"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LatestReadWithDate = void 0;
var date_fns_1 = require("date-fns");
var react_1 = __importStar(require("react"));
var core_1 = require("../../../../shared/core");
var copy_1 = require("../../copy");
var utils_1 = require("../../utils");
var getReadValue = function (_a) {
    var reading = _a.reading, timeOfUseLabel = _a.timeOfUseLabel, meterNumOfDigits = _a.meterNumOfDigits;
    if ('tiers' in reading) {
        var elecTier = reading.tiers.find(function (tier) { return tier.timeOfUseLabel === timeOfUseLabel; });
        return elecTier
            ? (0, utils_1.applyLeadingZeros)(meterNumOfDigits, Math.floor(elecTier.meterRegisterReading))
            : null;
    }
    else {
        return (0, utils_1.applyLeadingZeros)(meterNumOfDigits, Math.floor(reading.gasVolume));
    }
};
exports.LatestReadWithDate = (0, react_1.forwardRef)(function (_a, ref) {
    var reading = _a.reading, timeOfUseLabel = _a.timeOfUseLabel, meterNumOfDigits = _a.meterNumOfDigits, testId = _a["data-testid"], rest = __rest(_a, ["reading", "timeOfUseLabel", "meterNumOfDigits", 'data-testid']);
    var Copy = (0, core_1.useCopy)(copy_1.defaultOptions).Copy;
    var value = getReadValue({
        reading: reading,
        timeOfUseLabel: timeOfUseLabel,
        meterNumOfDigits: meterNumOfDigits,
    });
    var date = (0, date_fns_1.format)(reading.readingDateTime, 'd MMM yyyy');
    return value ? (react_1.default.createElement("span", __assign({ "data-testid": testId || 'latest-read-with-date' }, rest, { ref: ref }),
        react_1.default.createElement(Copy, { copyKey: "latestReadWithDate", values: { value: value, date: date } }))) : (react_1.default.createElement(Copy, { copyKey: "noLatestRead" }));
});
